var map = {
	"./new_s_variant_1.json": [
		46266,
		6266
	],
	"./new_s_variant_2.json": [
		42300,
		2300
	],
	"./new_s_variant_eur_1.json": [
		49319,
		9319
	],
	"./new_s_variant_eur_2.json": [
		2228,
		2228
	],
	"./new_s_variant_gbp_1.json": [
		94869,
		4869
	],
	"./new_s_variant_gbp_2.json": [
		56910,
		6910
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36807;
module.exports = webpackAsyncContext;